import React from 'react';

const TYPES = {
  dataset:     { label: 'Dataset',      color: '#1D4ED8', bg: '#EFF6FF' },
  llm:         { label: 'LLM',          color: '#6D28D9', bg: '#F5F3FF' },
  image_model: { label: 'Image Model',  color: '#BE185D', bg: '#FDF2F8' },
  cv_model:    { label: 'CV Model',     color: '#C2410C', bg: '#FFF7ED' },
  audio_model: { label: 'Audio Model',  color: '#047857', bg: '#ECFDF5' },
  embedding:   { label: 'Embedding',    color: '#0369A1', bg: '#F0F9FF' },
  other_model: { label: 'Other Model',   color: '#6D28D9', bg: '#F5F3FF' },
  notebook:    { label: 'Notebook',     color: '#92400E', bg: '#FFFBEB' },
  pipeline:    { label: 'Pipeline',     color: '#374151', bg: '#F9FAFB' },
};

export default function TypeBadge({ type, size = 'sm' }) {
  const t = TYPES[type] || { label: type || 'Asset', color: '#374151', bg: '#F9FAFB' };
  return (
    <span style={{
      display: 'inline-block',
      padding: size === 'sm' ? '2px 8px' : '3px 10px',
      borderRadius: 4,
      fontSize: size === 'sm' ? 11 : 12,
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: t.color,
      background: t.bg,
      border: `1px solid ${t.color}22`,
    }}>
      {t.label}
    </span>
  );
}

export { TYPES };
